var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-849 -483)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(849 483)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#26B963",
    cx: 19.5,
    cy: 19.5,
    r: 19.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M16.291,68.24a.827.827,0,0,0-1.169,0l-9.9,9.9L1.411,74.337A.827.827,0,0,0,.242,75.506L4.633,79.9a.827.827,0,0,0,1.169,0L16.291,69.409A.827.827,0,0,0,16.291,68.24Z",
    transform: "translate(860.001 428.003)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.fbd140e26c49e527db57b22fcf5c88e3.svg";
export { ForwardRef as ReactComponent };